// // src/layouts/ReporterLayout.jsx
// import React from 'react';
// import Sidebar from '../components/common/Sidebar'; // **CORRECTED Path**
// import Navbar from '../components/common/Navbar';   // **CORRECTED Path**

// const ReporterLayout = ({ children }) => {
//   return (
//     <div style={{ display: 'flex' }}>
//       <Sidebar role="reporter" /> {/* Dynamic Sidebar for reporter */}
//       <div style={{ flexGrow: 1 }}>
//         <Navbar role="reporter" /> {/* You can also pass role to Navbar */}
//         <div className="p-4">
//           {children} {/* This is where the actual page content (e.g., Dashboard) is rendered */}
//         </div>
//       </div>
//     </div>
//   );
// };
// export default ReporterLayout;

// src/layouts/ReporterLayout.jsx

import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/common/Sidebar';
import Navbar from '../components/common/Navbar';

const ReporterLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const closeSidebar = () => setIsSidebarOpen(false);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const sidebarWidth = 220;

  return (
    <div>
      {/* Sidebar */}
      <Sidebar role="reporter" isOpen={isSidebarOpen} closeSidebar={closeSidebar} />

      {/* Mobile Overlay */}
      {isSidebarOpen && windowWidth < 768 && (
        <div
          className="overlay d-md-none"
          onClick={closeSidebar}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 1040,
          }}
        />
      )}

      {/* Main Content */}
      <div
        className={`content ${isSidebarOpen ? 'pe-none' : ''}`}
        style={{
          marginLeft: windowWidth >= 768 ? `${sidebarWidth}px` : '0px',
          transition: 'margin-left 0.3s ease-in-out',
        }}
      >
        <Navbar role="reporter" toggleSidebar={toggleSidebar} />
        <div className="p-4" style={{ marginTop: '56px' }}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default ReporterLayout;
